import { readArticleOverrideMsg } from './message-exchange.utils';

export interface OverrideMessage {
  payload: ArticleOverride | null;
}

export interface ArticleOverride {
  trackingNumber: string | null;
  address: {
    line1: string | null;
    line2: string | null;
    line3: string | null;
    suburb: string | null;
    state: string | null;
    postcode: string | null;
  };
}

export function readOverrides(): ArticleOverride[] {
  const messages: OverrideMessage[] = readArticleOverrideMsg();
  return handleOverrideOutput(messages);
}

export function handleOverrideOutput(messages: OverrideMessage[]) {
  const articles: ArticleOverride[] = [];

  messages &&
    messages.forEach((articleMessage) => {
      const payload: ArticleOverride | null = articleMessage.payload;
      if (payload) {
        articles.push(payload);
      }
    });
  return articles;
}

// TODO: notification overrides
// export const readNotificationOverrides = (): any[] => {
//   const messages: Array<any> = readMxTrackUi('overrideNotification');
//   const notifications: any[] = [];

//   messages.forEach((articleMessage) => {
//     const payload = articleMessage.payload;
//     if (payload) {
//       notifications.push(payload);
//     }
//   });

//   return notifications;
// };
